import operations from '../../../../../dialogs/operations';
import { LOCATIONS_DIALOG } from '../constants';
export const openLocationDialog = (dialogProps = {}) => {
    operations.show(LOCATIONS_DIALOG, { ...dialogProps });
};
